import type { ComboboxInputOptionProps } from "./ComboboxInput.types";

export default function ComboboxInputOption({
  label,
  isSelected,
  multi,
}: ComboboxInputOptionProps) {
  if (multi) {
    return (
      <label className="curline-clamp-1 flex size-full h-10 max-w-full items-center gap-2 rounded-md p-1">
        <span className="line-clamp-1 w-full text-ellipsis">{label}</span>
        <input
          className="border-tertiary-800 checked:bg-tertiary-800 checked:hover:bg-tertiary-800 pointer-events-none size-4 rounded-sm border-2"
          type="checkbox"
          role="none"
          checked={isSelected}
          tabIndex={-1}
        />
      </label>
    );
  }

  return (
    <button
      type="button"
      role="none"
      aria-selected={isSelected}
      className="pointer-events-none line-clamp-1 flex h-10 w-full items-center justify-between text-ellipsis rounded-md p-1 text-left aria-selected:bg-tertiary-200"
      tabIndex={-1}
    >
      <span className="line-clamp-1 w-11/12 text-ellipsis">{label}</span>{" "}
    </button>
  );
}
